<template>
  <ActionGeneric :to="to" :btnClasses="btnClasses" :btnClassesMobile="btnClassesMobile" :disabled="disabled" label="Modifica" iconClass="fas fa-pencil-alt" />
</template>

<script>

import actionMixin from './mixins/action';

export default {
  name: 'action-edit',
  mixins: [actionMixin],
  components: {
    ActionGeneric: () => import('./ActionGeneric'),
  },
};

</script>
